export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig();
  const prefixSourceUrl = runtimeConfig.public.storageBase || '';
  return {
    provide: {
      storage: {
        previewFile: (file: any) => {
          if (!file) return '/images/contents/ic-carousel-image-noimage.svg';

          if (typeof file.filePath === 'string') {
            const fp = file.filePath;
            if (
              [
              '.doc', '.docx', '.dot', '.pdf', '.txt', '.text', '.html', '.htm', '.shtml',
              '.json', '.csv', '.js', '.ehtml', '.shtm'
              ].some(ext => fp.toLowerCase().endsWith(ext))
            ) {
              return '/images/contents/ic-carousel-image-noimage.svg';
            }

            if (fp.startsWith('http://') || fp.startsWith('https://') || fp.startsWith('data:') || fp.startsWith('blob:')) {
              return fp;
            }
          }

          if (file.displayFile) return file.displayFile;
          if (file.url) return file.url;

          const mime = file.mimeType || file.type || (file.file && file.file.type);

          if (mime && !mime.startsWith('image/')) {
            return '/images/contents/ic-carousel-image-noimage.svg';
          }

          if (!file.filePath) return '/images/contents/ic-carousel-image-noimage.svg';

          const base = runtimeConfig.public.storageBase || '';
          const rawPath = String(file.filePath).replace(/^\/+/, '');
          const url = base ? `${base}/${encodeURI(rawPath)}` : encodeURI(rawPath);
          return url;
        },
        previewAudio: (file: any) => {
          if (!file) return null;

          if (file.displayFile) return file.displayFile;
          if (file.url) return file.url;

          if (typeof file.filePath === 'string') {
            const fp = file.filePath;
            if (fp.startsWith('http://') || fp.startsWith('https://') || fp.startsWith('data:') || fp.startsWith('blob:')) {
              return fp;
            }
          }

          if (!file.filePath) return null;

          const base = runtimeConfig.public.storageBase || '';
          const rawPath = String(file.filePath).replace(/^\/+/, '');
          const url = base ? `${base}/${encodeURI(rawPath)}` : encodeURI(rawPath);
          return url;
        },
        previewSourceUrl: (esUrl: any) => {
          if (esUrl.startsWith('http://') || esUrl.startsWith('https://') || esUrl.startsWith('data:') || esUrl.startsWith('blob:')) {
            return esUrl;
          }
          const rawPath = String(esUrl).replace(/^\/+/, '');
          const url = prefixSourceUrl ? `${prefixSourceUrl}/${encodeURI(rawPath)}` : encodeURI(rawPath);
          return url;
        },
      },
    },
  };
});
